<template>
  <div class="q-pa-md" style="max-width: 400px; margin: auto;">
    <q-card>
      <q-card-section>
        <div class="text-h6">Вход в систему</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="submitLogin" class="q-gutter-md">
          <q-input v-model="username" label="Имя пользователя" filled autofocus />
          <q-input v-model="password" type="password" label="Пароль" filled />
          <q-btn label="Войти" type="submit" color="primary" class="full-width" />
          <div v-if="errorMessage" class="text-negative q-mt-sm">{{ errorMessage }}</div>
        </q-form>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const username = ref('')
const password = ref('')
const errorMessage = ref('')
const router = useRouter()
const authStore = useAuthStore()

const submitLogin = async () => {
  errorMessage.value = ''
  try {
    await authStore.login(username.value, password.value)
    await router.push('/')
  } catch (err) {
    errorMessage.value = err.message
  }
}
</script>
